import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getSessions = (data: PropertyType): Promise<PropertyType> =>
	api.post(`players/sessions${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});

export const getSessionsExport = (data: PropertyType): Promise<PropertyType> =>
	api.post(`export/sessions${data?.query}`, { sid: data.token }, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
